import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-display',
  template: `
    <ng-container [ngSwitch]="type">
      <!-- the same view can be shown in more than one case -->
      <ng-container *ngSwitchCase="'currency'">{{ value | currencyTranslate }}</ng-container>
      <ng-container *ngSwitchCase="'number'">{{ value | number }}</ng-container>
      <ng-container *ngSwitchCase="'date'">{{ value | dateTranslate}}</ng-container>
      <ng-container *ngSwitchCase="'keyword'">{{ value }}&nbsp;</ng-container>
      <!--default case when there are no matches -->
      <ng-container *ngSwitchDefault>{{ value }}</ng-container>
    </ng-container>
  `
})
export class DisplayComponent implements OnInit {
  @Input() type: 'number' | 'currency' | 'date' | 'string' = 'string';
  @Input() value: any;

  constructor() { }

  ngOnInit(): void {
    // Log.debug((this.type ? this.type : 'string') + ':', this.value);
  }

}
